































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
import detailRecord from '@/views/sheet/detailRecord.vue'
import {AppModule} from '@/store/modules/app'
import {getSheetConfig} from '@/apis/sheetConfig'
import {getRecordById} from '@/apis/sheet'
import {getUndoDetail, approvalPass, approvalRefuse, approvalRollback, refreshMineItem, refreshUndoItem} from '@/apis/home'
import {permissionE} from '@/views/sheet/widget/types'
import {authorityShow} from '@/utils/common'
import {Toast} from 'vant'
@Component({
  name: 'approvalBox',
  components: {
    detailRecord
  }
})
export default class App extends Vue {
  @Ref() private detailRecordRef!: detailRecord
  private activeName = ''
  private actionShow = false
  private isShowRecord = false
  private form = {
    state: '',
    feedback: '',
    rollBackTargetNodeId: ''
  }
  private stateFlag = Object.freeze({
    running: {
      text: '#1890ff',
      background: '#e8f4ff'
    },
    success: {
      text: '#58CC1F',
      background: '#EDFFE0'
    },
    failure: {
      text: '#F23030',
      background: '#FFF0F0'
    }
  })
  private stateName = Object.freeze({
    running: '审批中',
    success: '通过',
    failure: '未通过'
  })
  private priorityAuth = {}
  private isAdmin = false
  private sheetFieldList: any = []
  private detail: any = {}
  private approvalData: any = {
    rollbackItemList: []
  }
  private titleBusinessId = ''
  private get btnColor () {
    let state = this.form.state
    if (state === 'rollBackButtonText') {
      return '#F5BC00'
    } else if (state === 'passByButtonText') {
      return '#58CC1F'
    } else if (state === 'rejectButtonText') {
      return '#1A8CFF'
    }
  }
  private dialogVisible = false
  private openRecord (globalRecord) {
    this.activeName = globalRecord.type
    if (!this.activeName) {
      return
    }
    this.isShowRecord = true
    this.$nextTick(() => {
      this.detail = globalRecord.data
      if (globalRecord.type === 'undo') {
        this.getUndoDetail()
      } else {
        this.getDetail()
      }
    })
  }
  private onSelect (item) {
    this.approval('rollBackButtonText', item)
  }
  private getUndoDetail () {
    let {sheetId, nodeId, recordId, flowId, processId} = this.detail
    let req1 = getSheetConfig({worksheetId: sheetId, queryFieldType: 1, isQueryView: false, isNeedAuthority: true})
    let req2 = getUndoDetail({sheetId, nodeId, recordId, flowId, processId})
    Promise.all([req1, req2]).then(([res1, res2]) => {
      let approvalAuth = {}
      res2.data.fieldAuthorities.forEach(({fieldId, authority}) => {
        approvalAuth[fieldId] = authority
      });
      res1.data.fields.forEach((item) => {
        if (!approvalAuth[item.businessId]) {
          approvalAuth[item.businessId] = item.permissions && item.permissions.includes(permissionE.hidden) ? 'hidden' : 'visible'
        }
      })
      this.priorityAuth = approvalAuth
      this.sheetFieldList = res1.data.fields
      this.titleBusinessId = res1.data.titleField
      this.isAdmin = res1.data.isAdmin
      
      let {passByButtonText, rejectButtonText, rollBackButtonText, rollbackType, rollbackItemList = []} = res2.data
      let {showReject, showRollBack, showPass} = res2.data 
      this.approvalData = {showReject, showRollBack, showPass, passByButtonText, rejectButtonText, rollBackButtonText, rollbackType, rollbackItemList}
      if (this.approvalData.rollbackItemList.length) {
        this.approvalData.rollbackItemList[0].nodeName = this.approvalData.rollbackItemList[0].nodeName + '(上一个节点)'
      }
      this.approvalData.rollbackItemList.forEach((item) => {
        item.name = item.nodeName
      })
      this.$nextTick(() => {
        this.detailRecordRef.initForm(res2.data.data)
      })
    })
  }
  private getDetail () {
    let {sheetId, nodeId, recordId, state} = this.detail
    let req1 = getSheetConfig({worksheetId: sheetId, queryFieldType: 1, isQueryView: false, isNeedAuthority: true})
    let req2 = getRecordById({worksheetId: sheetId, id: recordId})
    Promise.all([req1, req2]).then(([res1, res2]) => {
      this.sheetFieldList = res1.data.fields
      this.titleBusinessId = res1.data.titleField
      this.isAdmin = res1.data.isAdmin
      let lockAuth = {}
      if (res2.data.lockFieldAuthority) {
        res2.data.lockFieldAuthority.forEach(({businessId, authority}) => {
          lockAuth[businessId] = authority
        });
        res1.data.fields.forEach((item) => {
          if (!lockAuth[item.businessId]) {
            lockAuth[item.businessId] = item.permissions && item.permissions.includes(permissionE.hidden) ? 'hidden' : 'visible'
          }
        })
      }
      this.priorityAuth = lockAuth
      this.$nextTick(() => {
        this.detailRecordRef.initForm(res2.data)
      })
    })
  }
  private backErrorMessage () {
    if (!this.approvalData.rollbackItemList.length) {
      // this.$message.error('暂无上一个节点')
      Toast.fail({
        duration: 2000,
        message: '暂无上一个节点'
      })
      return false
    }
    return true
  }
  private approval (type, item) {
    if (type === 'rollBackButtonText') {
      if (!this.backErrorMessage()) {
        return
      }
      this.form.rollBackTargetNodeId = item.nodeId
    }
    this.form.state = type
    this.form.feedback = ''
    let map1 = {
      rollBackButtonText: 'showRollBack',
      passByButtonText: 'showPass',
      rejectButtonText: 'showReject',
    }
    let key = map1[type]
    if (this.approvalData[key]) {
      this.dialogVisible = true
    } else {
      this.saveApproval()
    }
  }
  private backAction () { 
    if (!this.backErrorMessage()) {
      return
    }
    if (this.approvalData.rollbackType === 'pre') {
      this.approval('rollBackButtonText', this.approvalData.rollbackItemList[0])
    } else if (this.approvalData.rollbackType === 'select') {
      this.actionShow = true
    }
  }
  private async saveApproval () {
    let {approvalRecordId, flowId, nodeId, processId, recordId} = this.detail
    let {feedback} = this.form
    let res: any
    if (this.form.state === 'passByButtonText') {
      res = await approvalPass({approvalRecordId, flowId, nodeId, processId, recordId, feedback})
    } else if (this.form.state === 'rejectButtonText') {
      res = await approvalRefuse({approvalRecordId, flowId, nodeId, processId, recordId, feedback})
    } else if (this.form.state === 'rollBackButtonText') {
      res = await approvalRollback({approvalRecordId, rollBackTargetNodeId: this.form.rollBackTargetNodeId, feedback})
    }
    if (res.success) {
      this.dialogVisible = false
      this.$router.go(-1)
    }
  }
  private async mounted () {
    let {tabName, processId, nodeId} = this.$route.params
    let globalRecord = {type: tabName === 'upcoming' ? 'undo' : 'mine', data: {}}
    if (globalRecord.type === 'mine') {
      let res = await refreshMineItem(processId)
      if (res.success) {
        globalRecord.data = res.data
        this.openRecord(globalRecord)
      }
    } else {
      let res = await refreshUndoItem({processId, nodeId})
      if (res.success) {
        globalRecord.data = res.data
        this.openRecord(globalRecord)
      }
    } 
  }
}
